module.exports = __webpack_public_path__ + "static/antd-notification-274b4e426e061804d5753f46c06d36f2.png";